import { useCallback, useState } from 'react';

export function useExpandedSteps() {
  const [expandedIDs, setExpandedIDs] = useState(new Set());

  const isExpanded = useCallback((id) => expandedIDs.has(id), [expandedIDs]);
  const onExpandedChange = useCallback((id, shouldBeExpanded) => {
    setExpandedIDs((oldIDSet) => {
      // Make a copy initially, otherwise if we just modify oldIDSet React won't think we changed anything
      const newIDSet = new Set(oldIDSet);
      // Adjust the newIDSet to match what the user wants it to be
      if (shouldBeExpanded) {
        newIDSet.add(id);
      }
      if (!shouldBeExpanded) {
        newIDSet.delete(id);
      }

      return newIDSet;
    });
  }, []);

  return { isExpanded, onExpandedChange };
}
